import React, { useState } from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { colors, dimensions, fonts } from './Theme';

import { ReactComponent as BurgerIcon } from './images/hamburger.svg';
import { ReactComponent as CrossIcon } from './images/close.svg';
import { ReactComponent as FacebookLogo } from './images/facebook-logo.svg';
import { ReactComponent as InstaLogo } from './images/instagram-logo.svg';

import { FACEBOOK_LINK, INSTA_LINK } from '../../services/Configs';
import Button from './elements/Button';
import { HREF as COVERAGE_HREF } from '../../../pages/assurance/garanties';
import { HREF as INSURANCE_HREF } from '../../../pages/assurance';
import { PROFILE_HREF } from '../../../pages/profile';

const componentStyles = css`
  .header {
    display: flex;
    flex-direction: row;
    background-color: white;
    padding: 0;
    box-shadow: 5px 5px 16px 0 rgba(121, 121, 121, 0.3);
    z-index: 100;
  }
  .menu__wrapper {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    max-width: ${dimensions.ywgSectionMaxWidth};
    justify-content: flex-end;
  }
  .menu__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 62px;
    height: 100%;
    border-top: none;
    border-bottom: none;
    border-left: none;
    border-right: 1px solid rgba(${colors.ywgNavyRgb}, 0.15);
    margin-right: 15px;
    padding-left: 19px;
    padding-right: 19px;
    cursor: pointer;
    background: transparent;
  }
  .menu__icon:focus {
    outline: none;
  }
  .header__logo {
    width: 130px;
    height: 30px;
    background: no-repeat url('/static/images/logo.svg') left center;
  }
  .menu {
    display: flex;
    flex-direction: column;
    transition: all 0.5s ease 0s;
    flex-grow: 1;
    list-style: none;
    background: #ffffff;
    z-index: 1100;
  }

  .nav-menu {
    flex-grow: 1;
  }

  .menu__item {
    position: relative;
    display: inline-flex;
    flex-direction: column;
  }

  .icon::before {
    position: absolute;
    display: block;
    left: 0;
    top: 50%;
    content: '';
    background-repeat: no-repeat;
    background-size: contain;
    transform: translateY(-50%);
  }
  .icon--concept::before {
    width: 17px;
    height: 25px;
    background-image: url('/static/images/ic-communaute.svg');
  }
  .icon--temoignage::before {
    width: 20px;
    height: 15px;
    background-image: url('/static/images/guillemets.svg');
  }
  .icon--contract::before {
    width: 15px;
    height: 20px;
    background-image: url('/static/images/ic-assurance.svg');
  }

  .subnav-links {
    margin: 0;
    padding: 10px 20px 20px;
    justify-content: space-around;
    text-align: center;
    background-color: white;
    list-style: none;
    box-sizing: border-box;
    z-index: 1000;
  }

  .subnav-link {
    display: flex;
    font-size: 1rem;
    line-height: 1.4;
  }

  .subnav-link:hover,
  .subnav-link:focus {
    color: ${colors.ywgPinkishOrangeStrong};
  }

  .subnav-link-item:not(:last-of-type) {
    margin-bottom: 20px;
  }

  .menu__item:hover > .subnav-links,
  .menu__item:focus-within > .subnav-links {
    display: block;
  }

  @media screen and (max-width: 902px) {
    .menu {
      width: 100%;
      padding: 20px;
      font-size: 1.15em;
      box-shadow: inset 0 2px 2px 0 rgba(0, 0, 0, 0.1);
      position: fixed;
      left: -960px;
      top: 60px;
      right: 0;
      box-sizing: border-box;
      margin: 0;
      width: 100%;
      height: 100%;
      transition: all 0.5s ease 0s;
    }

    .user {
      flex-grow: 1;
      text-align: right;
      padding-right: 1.25rem;
    }
  }
  @media screen and (min-width: 903px) {
    .menu {
      flex-direction: row;
      justify-content: flex-end;
      padding: 10px;
    }
    .menu__wrapper {
      width: 100%;
      margin: auto;
      padding: 0 10px;
      align-items: center;
      flex-wrap: wrap;
      box-sizing: border-box;
      height: auto;
    }
    .menu__icon {
      display: none;
    }

    .header__logo {
      width: 250px;
      height: 58px;
      background-image: url('/static/images/logo-color-baseline.svg');
      background-size: contain;
    }

    .subnav-links {
      position: absolute;
      display: none;
      padding: 20px;
      top: 100%;
      left: -50%;
      white-space: nowrap;
      box-shadow: 0px 0px 34px 0 rgba(210, 210, 210, 0.5);
    }
    .subnav-link {
      justify-content: center;
    }
  }

  .bm-menu {
    left: 0px;
  }

  a {
    color: ${colors.ywgNavy};
  }
`;

const communityIconStyles = css.resolve`
  .community-icon {
    margin-right: 10px;
  }
`;

const headerLinkStyles = css.resolve`
  .header-link {
    font-family: ${fonts.secondaryFont};
    font-size: 1rem;
    line-height: 1.4;
    position: relative;
    padding: 1.25rem 1.25rem 1.25rem 1.5rem;
  }

  .header-link:hover,
  .header-link:focus {
    color: ${colors.ywgPinkishOrangeStrong};
  }
`;

const userLinkStyles = css`
  .user-icon-container {
    position: relative;
    display: inline-block;
  }
  .user-icon-container::before {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 6px;
    height: 6px;
    content: '';
    background-color: #3ac451;
    border-radius: 50%;
  }
`;
const dynUserLinkStyles = css.resolve`
  .user-icon {
    vertical-align: middle;
  }
  .user-icon-link:focus,
  .user-icon-link:hover {
    filter: ${colors.ywgPrimaryFilter};
  }
  .user-icon-link {
    padding: 1.25rem 1.25rem 1.25rem 1.5rem;
  }

  .button {
    margin: auto 6px;
    padding: 12px;
  }

  @media (min-width: 903px) {
    .user-link::before {
      content: '';
      border-left: 1px solid ${colors.ywgPaleGrey};
      vertical-align: middle;
    }
  }
`;
const items = [
  {
    text: 'Assurance',
    icon: 'contract'
  },
  {
    href: null,
    text: 'Communauté',
    icon: 'concept'
  },
  {
    href: '/blog',
    text: 'Blog',
    icon: 'temoignage'
  }
];

const UserLink = ({ profile }) => {
  const link = profile ? '/profile' : '/souscrire';
  return (
    <>
      {profile ? (
        <Link href={link}>
          <a
            href={link}
            className={classnames(
              dynUserLinkStyles.className,
              'user-link',
              'user-icon-link'
            )}
          >
            <span className="user-icon-container">
              <img
                src="/static/images/icons/user.svg"
                className="user-icon"
                width="26"
                height="34"
                alt="Mon profil"
              />
            </span>
          </a>
        </Link>
      ) : (
        <Link href={link}>
          <Button
            href={link}
            className={classnames('user-link', dynUserLinkStyles.className)}
          >
            Souscrire
          </Button>
        </Link>
      )}
      <style jsx>{userLinkStyles}</style>
      {dynUserLinkStyles.styles}
    </>
  );
};

const Header = ({ profile, className }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [bodyOverflow, setBodyOverflow] = useState(null);
  const openMenu = () => {
    setMenuOpen(true);
    setBodyOverflow(document.body.style.overflow);
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.style.overflow = bodyOverflow;
  };

  const navigate = event => {
    closeMenu(event);
  };

  const toggleMenu = () => {
    menuOpen === true ? closeMenu() : openMenu();
  };

  return (
    <header className={classnames('header', className)}>
      <div className="menu__wrapper">
        <button className="menu__icon" onClick={toggleMenu}>
          {menuOpen ? (
            <CrossIcon aria-label="Fermer le menu" />
          ) : (
            <BurgerIcon aria-label="Ouvrir le menu" />
          )}
        </button>
        <Link href="/">
          <a href="/" className="header__logo">
            <span className="sr-only">YUPWEGO</span>
          </a>
        </Link>

        <nav className="nav-menu">
          <ul
            className={classnames('menu', {
              'bm-menu': menuOpen
            })}
          >
            {items.map(item => (
              <li className="menu__item" key={item.icon}>
                {item.href ? (
                  <Link href={item.href}>
                    <a
                      className={classnames(
                        'header-link',
                        headerLinkStyles.className,
                        'icon',
                        `icon--${item.icon}`
                      )}
                      href={item.href}
                      onClick={navigate}
                    >
                      {item.text}
                    </a>
                  </Link>
                ) : (
                  <span
                    className={classnames(
                      'header-link',
                      'subnav-header',
                      headerLinkStyles.className,
                      'icon',
                      `icon--${item.icon}`
                    )}
                  >
                    {item.text}
                  </span>
                )}
                {item.icon === 'contract' ? (
                  <ul className="subnav-links">
                    <li className="subnav-link-item">
                      <a href={INSURANCE_HREF} className="subnav-link">
                        <span className="community-label">Offre</span>
                      </a>
                    </li>
                    <li className="subnav-link-item">
                      <a href={COVERAGE_HREF} className="subnav-link">
                        <span className="community-label">Garanties</span>
                      </a>
                    </li>
                    <li className="subnav-link-item">
                      <a href={PROFILE_HREF} className="subnav-link">
                        <span className="community-label">Espace client</span>
                      </a>
                    </li>
                  </ul>
                ) : null}
                {item.icon === 'concept' ? (
                  <ul className="subnav-links">
                    <li className="subnav-link-item">
                      <a href={FACEBOOK_LINK} className="subnav-link">
                        <FacebookLogo
                          className={classnames(
                            'community-icon',
                            communityIconStyles.className
                          )}
                          aria-hidden="true"
                        />
                        <span className="community-label">
                          YUPWEGO sur Facebook
                        </span>
                      </a>
                    </li>
                    <li className="subnav-link-item">
                      <a href={INSTA_LINK} className="subnav-link">
                        <InstaLogo
                          className={classnames(
                            'community-icon',
                            communityIconStyles.className
                          )}
                          aria-hidden="true"
                        />
                        <span className="community-label">
                          YUPWEGO sur Instagram
                        </span>
                      </a>
                    </li>
                  </ul>
                ) : null}
              </li>
            ))}
          </ul>
        </nav>
        <UserLink profile={profile} />
      </div>
      <style jsx>{componentStyles}</style>
      {headerLinkStyles.styles}
      {communityIconStyles.styles}
    </header>
  );
};

Header.propTypes = {
  profile: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  className: PropTypes.string
};

export default Header;
